import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { freeze } from 'immer';
import type { Currency, OrderStrategy } from '../../../../types';
import type { MarketAccountsRefData, OMSReferenceDataState, SecuritiesReferenceData } from './types';

const initialRefDataState: OMSReferenceDataState = {
  securities: {
    securitiesList: [],
    securitiesBySymbol: new Map(),
  },
  marketAccounts: {
    customerMarketAccountsList: [],
    customerMarketAccountsBySourceAccountID: new Map(),
  },
  strategiesBySymbol: new Map(),
  currencies: {
    currenciesList: [],
    currenciesBySymbol: new Map(),
  },
  favoredPairCurrency: undefined,
  homeCurrency: undefined,
};

const referenceDataSlice = createSlice({
  name: 'referenceData',
  initialState: initialRefDataState,
  reducers: {
    setStrategiesBySymbol: (state, action: PayloadAction<Map<string, OrderStrategy[]>>) => {
      state.strategiesBySymbol = freeze(action.payload);
    },

    setSecurities: (state, action: PayloadAction<SecuritiesReferenceData>) => {
      state.securities = freeze(action.payload);
    },

    setMarketAccounts: (state, action: PayloadAction<MarketAccountsRefData>) => {
      state.marketAccounts = freeze(action.payload);
    },
    setCurrencies: (state, action: PayloadAction<OMSReferenceDataState['currencies']>) => {
      state.currencies = freeze(action.payload);
    },

    setFavoredPairCurrency: (state, action: PayloadAction<Currency>) => {
      state.favoredPairCurrency = freeze(action.payload);
    },

    setHomeCurrency: (state, action: PayloadAction<Currency>) => {
      state.homeCurrency = freeze(action.payload);
    },

    __setReferenceData: (state, action: PayloadAction<OMSReferenceDataState>) => {
      /**
       * You should not be using this other than from tests
       */
      return action.payload;
    },
  },
});

export const {
  setSecurities,
  setMarketAccounts,
  __setReferenceData,
  setStrategiesBySymbol,
  setCurrencies,
  setFavoredPairCurrency,
  setHomeCurrency,
} = referenceDataSlice.actions;

export const referenceDataSliceReducer = referenceDataSlice.reducer;
